import { JSONSchema7 } from 'json-schema';
import JSONSchema7Properties from '../../../Shared/jSONSchema7Properties';
import { OptionOrientation } from '../../../Shared/Enums/optionOrientation';

export default (currVer: JSONSchema7): JSONSchema7 => {
  let properties = currVer.properties as JSONSchema7Properties;

  properties['version'].default = 7;

  properties = {
    ...properties,
    optionOrientation: {
      $id: `${currVer.$id}/optionOrientation`,
      default: OptionOrientation.VERTICAL,
      type: 'string'
    }
  };
  return {
    ...currVer,
    properties
  };
};
